import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Subject } from 'rxjs';
import { Router } from '@angular/router';
import 'firebase/auth';
import { Response } from '../../models';
import { ProcessorService } from './processor.service';
import {
  getAuth,
  signInWithEmailAndPassword,
  UserCredential,
  browserLocalPersistence
} from 'firebase/auth';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  public showLoginLoader = new Subject<boolean>();
  private sessionTokenSource: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  private _processorUid: BehaviorSubject<string> = new BehaviorSubject<string>(null);

  get currentProcessorUid() {
    return this._processorUid.value;
  }


  get sessionToken$() {
    return this.sessionTokenSource
      .asObservable();
  }

  get sessionTokenRaw() {
    return this.sessionTokenSource.value;
  }

  constructor(private http: HttpClient,
              private processorService: ProcessorService,
              private router: Router) {
    getAuth().onIdTokenChanged(async (user) => {
      this._processorUid.next(user.uid);
      if (!!user) {
        const sessionToken = await user.getIdToken();
        this.sessionTokenSource.next(sessionToken);
      } else {
        this.router.navigateByUrl('/login');
        this.sessionTokenSource.next(null);
      }
    });
  }



  login(email: string, password: string): Promise<boolean> {
    const auth = getAuth()

    this.showLoginLoader.next(true);

    auth.setPersistence(browserLocalPersistence)
      .then(() => {
      })
      .catch(err => {
        console.error('PERSISTENCE ERROR:', err);
      });

    return new Promise((resolve, reject) => {
      signInWithEmailAndPassword(auth, email, password)
        .then((userCredential: UserCredential) => {

          this.processorService.getProcessor()
            .subscribe((processorResponse: Response) => {
              const processor = processorResponse.data;
              if (!!processor) {
                processor['acceptedPolicies'] ?
                  this.router.navigateByUrl('home/jobs') :
                  this.router.navigateByUrl('/login/settings/termsandconditions');
              } else {
                this.router.navigateByUrl('/login/settings/termsandconditions');
              }
              resolve(null);
            });
        })
        .catch(e => {
          this.showLoginLoader.next(false);
          reject(e);
        });
    });
  }

  isLoggedIn() {
    return new Promise((resolve, reject) => {
      getAuth().onAuthStateChanged(user => {
        if (user) {
          resolve(user);
        }
        reject(false);
      });
    });
  }

  logout() {
    return getAuth().signOut()
      .then(success => this.router.navigate(['']))
      .catch(err => {
        window.location.reload();
      });
  }
}
